function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { ObservableUtils } from "trade_utils_lib";
var getAuthorizeRequest = function getAuthorizeRequest(url, params) {
  var authorize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return ObservableUtils.getV2(url, params, undefined, authorize);
};
var postAuthorizeRequest = function postAuthorizeRequest(url, params) {
  var authorize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return ObservableUtils.postV2(url, params, undefined, authorize);
};
var deleteRequest = function deleteRequest(url, params) {
  var authorize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return ObservableUtils.delete(url, params, undefined, authorize);
};
export var KolFHost = "/kol-apis/fapi/v1";
export var KolTHost = "/kol-apis/tapi/v1";

/**
 * @doc https://pionex.atlassian.net/wiki/spaces/backend/pages/138248867/KOL+Home+API#%E8%B7%9F%E5%8D%95%E5%B9%BF%E5%9C%BA
 * @description: 首页跟单列表
 * @param params
 * @param authorize
 */

export var queryOrderFeedDiscoverList = function queryOrderFeedDiscoverList(params, authorize) {
  return postAuthorizeRequest("".concat(KolFHost, "/order_feed_discover_list"), params, authorize);
};

/**
 * @doc https://pionex.atlassian.net/wiki/spaces/backend/pages/138248867/KOL+Home+API#%E5%B7%A5%E5%85%B7%E5%BC%80%E5%8D%95-%E6%8E%A8%E8%8D%90%E8%B7%9F%E5%8D%95%E5%88%97%E8%A1%A8
 * @description: 推荐跟单列表
 * @param params
 * @param authorize
 */

export var queryOrderFeedRecommendList = function queryOrderFeedRecommendList(params, authorize) {
  return postAuthorizeRequest("".concat(KolFHost, "/order_feed_recommend_list"), params, authorize);
};

/**
 * @doc https://pionex.atlassian.net/wiki/spaces/backend/pages/138248867/KOL+Home+API#%E6%9C%BA%E5%99%A8%E4%BA%BA%E7%BB%9F%E8%AE%A1%E6%95%B0%E6%8D%AE
 * @description 机器人统计数据
 * @param bu_order_id
 * @param bu_order_type
 * @returns
 */
export function queryBotStatisticOverview(bu_order_id, bu_order_type) {
  return ObservableUtils.get("".concat(KolTHost, "/statistic/overview"), {
    bu_order_id: bu_order_id,
    bu_order_type: bu_order_type
  });
}

/**
 *  @doc https://pionex.atlassian.net/wiki/spaces/backend/pages/138248867/KOL+Home+API#%E6%9C%BA%E5%99%A8%E4%BA%BA%E8%AF%A6%E6%83%85
 *  @description: 机器人详情
 * @param bu_order_id
 * @param bu_order_type
 * @param authorize
 */
export var queryOrderFeedListTradingBotOrder = function queryOrderFeedListTradingBotOrder(bu_order_id, bu_order_type, authorize) {
  return getAuthorizeRequest("".concat(KolFHost, "/trading_bot_order"), {
    bu_order_id: bu_order_id,
    bu_order_type: bu_order_type
  }, authorize);
};

/**
 * @description: 订单操作信息 https://pionex.atlassian.net/wiki/spaces/backend/pages/116654184/Pionex+Order
 * @param {string} bu_order_type
 * @param {string} copy_bu_order_id
 * @param {OrderFeedAction} action
 * @param key_id
 * @param swap_key_id
 * @param {string} amount
 * @return {*}
 */
export var cbOrderActionRequest = function cbOrderActionRequest(params) {
  return getAuthorizeRequest("".concat(KolTHost, "/order_action"), params, true);
};

/**
 * @description: 机器人订单post
 * @param {string} path
 * @param {Object} payload
 * @return {*}
 */
export var cbExecuteOrderActionPost = function cbExecuteOrderActionPost(path, payload) {
  return postAuthorizeRequest("".concat(path), _objectSpread({}, payload));
};

/**
 * @description: 机器人订单get
 * @param {string} path
 * @param {Object} payload
 * @return {*}
 */
export var cbExecuteOrderActionGet = function cbExecuteOrderActionGet(path, payload) {
  return getAuthorizeRequest("".concat(path), _objectSpread({}, payload));
};

/**
 * @description: 机器人订单delete
 * @param {string} path
 * @param {Object} payload
 * @return {*}
 */
export var cbExecuteOrderActionDelete = function cbExecuteOrderActionDelete(path, payload) {
  return deleteRequest("".concat(path), _objectSpread({}, payload));
};

/**
 * @description: 开单预设参数 https://pionex.atlassian.net/wiki/spaces/backend/pages/138248867/KOL+Home+API#%E5%BC%80%E5%8D%95%E9%A2%84%E8%AE%BE%E5%8F%82%E6%95%B0
 * @param {GridV4PresetListParam} params
 */
export var queryGridV4PresetCreateParams = function queryGridV4PresetCreateParams(params) {
  return postAuthorizeRequest("".concat(KolTHost, "/preset_create_params"), params, false);
};